import styled from 'styled-components';

import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

interface IHeading {
  sizeMobile?: number;
  fontWeight?: FontWeight;
  fontStyle?: 'italic' | 'normal' | 'oblique' | string;
  sizeDesktop?: number | string;
}

export const Heading = styled.h2<IHeading>`
  font-size: ${({ sizeMobile }) => `${sizeMobile || 56}px`};
  font-family: ${theme.font.family.brand};
  font-weight: ${({ fontWeight }) => `${fontWeight || 'medium'}`};
  font-style: ${({ fontStyle }) => `${fontStyle || 'normal'}`};
  margin: 0 auto;
  line-height: 1;
  max-width: ${size(100)};

  ${theme.screens.Md} {
    font-size: ${({ sizeDesktop }) => `${sizeDesktop || 80}px`};
  }
  ${theme.screens.LtXS} {
    font-size: ${({ sizeMobile }) => `${(sizeMobile && sizeMobile * 0.85) || 48}px`};
  }
`;
